module.exports = __webpack_public_path__ + "img/Vector.8a732239.svg";